export interface NavLink {
  label: string;
  href: string;
  description?: string;
  external?: boolean;
}

export interface NavMenu {
  label: string;
  items: NavLink[];
}

export const NAV_MENUS: NavMenu[] = [
  {
    label: "Explore",
    items: [
      {
        label: "Block Explorer",
        href: "https://explorer.kuber-coin.com/",
        description: "Blocks, transactions, and addresses",
        external: true,
      },
      {
        label: "Web Wallet",
        href: "https://wallet.kuber-coin.com/",
        description: "Send, receive, and manage KUBER",
        external: true,
      },
      {
        label: "RPC Dashboard",
        href: "https://rpc.kuber-coin.com/",
        description: "JSON-RPC console and documentation",
        external: true,
      },
      {
        label: "Network Stats",
        href: "https://explorer.kuber-coin.com/network",
        description: "Hashrate, difficulty, and volume",
        external: true,
      },
    ],
  },
  {
    label: "Build",
    items: [
      {
        label: "Source Code",
        href: "https://open.kuber-coin.com/",
        description: "Repository and contributions",
        external: true,
      },
      {
        label: "SDK",
        href: "https://docs.kuber-coin.com/sdk/",
        description: "Rust and TypeScript client libraries",
        external: true,
      },
      {
        label: "API Explorer",
        href: "https://explorer.kuber-coin.com/api-explorer",
        description: "REST and JSON-RPC documentation",
        external: true,
      },
    ],
  },
  {
    label: "Learn",
    items: [
      {
        label: "Whitepaper",
        href: "https://docs.kuber-coin.com/whitepaper",
        description: "Protocol specification and design rationale",
        external: true,
      },
      {
        label: "Mining Guide",
        href: "https://docs.kuber-coin.com/mining",
        description: "SHA-256d proof-of-work basics",
        external: true,
      },
      {
        label: "Documentation",
        href: "https://docs.kuber-coin.com/getting-started",
        description: "Getting started guide",
        external: true,
      },
    ],
  },
  {
    label: "Community",
    items: [
      {
        label: "Discussions",
        href: "https://forum.kuber-coin.com/",
        description: "Community forum",
        external: true,
      },
      {
        label: "Contributing",
        href: "https://docs.kuber-coin.com/contributing",
        description: "Guidelines for contributors",
        external: true,
      },
      {
        label: "Code of Conduct",
        href: "https://docs.kuber-coin.com/code-of-conduct",
        description: "Expectations for participants",
        external: true,
      },
    ],
  },
];
